import React from 'react';
import { Container } from 'reactstrap';
import InvitationEvaluationView from './InvitationEvaluationView';

const MailInbox = () => {
  document.title = 'List HPS';
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <InvitationEvaluationView />
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MailInbox;
